import React from 'react';
import ContactRow from './ContactRow';
import { FormattedMessage } from 'react-intl';
import randomstring from 'uuid/v4';

import Dialog from './DialogContacts';

import AddIcon from '@material-ui/icons/AddCircle';

export default class ContactsTable extends React.Component {
    state = {
        data: [],
    };

    static getDerivedStateFromProps(props, state) {
        if (props.data !== state.data) {
            state.data = props.data ? props.data : [];
            return state;
        }
        return null;
    }

    handleRowDel = (row) => {
        var index = this.state.data.indexOf(row);
        this.state.data.splice(index, 1);
        const event = {
            target: {
                name: 'contactos',
                value: this.state.data,
            },
        };
        this.setState({ data: this.state.data });
        this.props.onChange(event);
    };

    handleAddEvent = () => {
        var row = {
            id: randomstring(),
            tipo: undefined,
            valor: '',
            comentario: '',
        };
        this.setState({ open: row });
    };

    handleUpdateTable = (row) => {
        this.setState({ open: row });
    };

    handleClose = (row) => {
        if (row) {
            const { data } = this.state;
            const arr = [...data];
            const index = arr.map((i) => i.id).indexOf(row.id);
            if (index >= 0) {
                arr[index] = row;
            } else {
                arr.push(row);
            }

            this.setState({ data: arr, open: undefined });
            const event = {
                target: {
                    name: 'contactos',
                    value: arr,
                },
            };
            this.props.onChange(event);
        } else {
            this.setState({ open: undefined });
        }
    };

    render() {
        const { data, open } = this.state;
        const updaterow = this.handleUpdateTable;
        const delrow = this.handleRowDel;

        return (
            <div className={'container-table100 flex_full_column'}>
                <div className="flex_full_row align_center padding_bottom_24 width100">
                    <div className={'barlow_medium_italic c_slate_grey flex_full_row'}>
                        <FormattedMessage id="form_field_name_contacts" />
                    </div>
                    <AddIcon
                        className={'c_bluish hand'}
                        fontSize="large"
                        onClick={this.handleAddEvent}
                    />
                </div>
                <section className="flex_full_column table100">
                    <header className="flex_auto_row">
                        <div className="col"> <FormattedMessage id="type_label_type" /></div>
                        <div className="col"><FormattedMessage id="value" /></div>
                        <div className="col"><FormattedMessage id="type_label_comment" /></div>
                        <div className="" />
                    </header>
                    <div className="flex_full_column tbody">
                        {data &&
                            data.map((row, index) => {
                                return (
                                    <ContactRow
                                        {...this.props}
                                        data={row}
                                        key={randomstring()}
                                        id={index}
                                        onDelEvent={delrow}
                                        onEditEvent={updaterow}
                                    />
                                );
                            })}
                    </div>
                </section>
                {open && <Dialog {...this.props} value={open} onClose={this.handleClose} />}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/manage/provider/ContactsTable.js